import apiCall from "../../axios";
import queryString from "query-string";

const speaker = async (payload: any) => {
  try {
    const res = await apiCall("POST", `operator/speaker`, payload);
    return res.data;
  } catch (e) {
    if (e) return e;
    return { error: "Unknown Error" };
  }
};

export default speaker;
